// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAgZdeWQaIBPkULMr1_1XOXaRu2BAVap1c",
  authDomain: "nonamelist-43705.firebaseapp.com",
  projectId: "nonamelist-43705",
  storageBucket: "nonamelist-43705.firebasestorage.app",
  messagingSenderId: "877985787396",
  appId: "1:877985787396:web:89846596cd0db0222e0f51",
  measurementId: "G-QDXKN4P9ZR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);